module.exports = __webpack_public_path__ + "img/zoom-icon.ab5a21c.svg";